<script setup>
// Props
const props = defineProps({
    article: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                title: rawValue => rawValue?.title === undefined || typeof rawValue?.title === 'string',
                content: rawValue => rawValue?.content === undefined || typeof rawValue?.content === 'string',
                abstract: rawValue => rawValue?.abstract === undefined || typeof rawValue?.abstract === 'string'
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})

// Markdown
const { $md } = useNuxtApp()
const newsDescription = computed(() => $md.render(props.article?.content || ''))
const contentPageAbstract = computed(() => $md.render(props.article?.abstract || ''))

const mainHeadlineConfig = computed(() => {
    return {
        title: props?.article?.title,
        simple: true
    }
})
</script>

<template>
    <ContentMainHeadline v-if="article?.title" :content-main-headline-config="mainHeadlineConfig" />
    <h2 v-if="article?.abstract" class="content-page-subline" v-html="contentPageAbstract" />
    <div v-if="article?.content" class="content-page-description" v-html="newsDescription" />
</template>

<style lang="scss">
.content-page-subline {
    color: $content-page-subline;
    font-weight: 800;
    font-size: px2rem(14);
    line-height: px2rem(24);
    text-transform: uppercase;
    margin-block-end: 20px;
    max-width: 950px;

    @include bp(medium1) {
        font-size: px2rem(16);
        margin-block-end: 30px;
    }

    @include bp(large1) {
        font-size: px2rem(20);
    }
}

.content-page-description {
    margin-block-end: 30px;

    p,
    ul,
    ol {
        &:has(img) {
            max-width: 100%;
        }
    }

    img {
        display: block;
        margin: 60px auto 40px;
        border-radius: 32px;
        max-width: 100%;
        height: auto;
    }

    @include rte-text($mw: 950px);
}
</style>
